const AUTH_KEY = "yadnya_admin_auth";

export const getAdminAuth = () => {
  try {
    const value = localStorage.getItem(AUTH_KEY);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

export const setAdminAuth = (auth) => {
  localStorage.setItem(AUTH_KEY, JSON.stringify(auth));
};

export const clearAdminAuth = () => {
  localStorage.removeItem(AUTH_KEY);
};

export const getAdminToken = () => {
  const auth = getAdminAuth();
  return auth?.token || auth?.accessToken || null;
};
